import type { TabId } from './TabNavigation';

/** Drawer sections a detail-page card can open the editor straight onto. */
export type PropertyDrawerSection = 'description' | 'amenities' | 'ownership' | 'documentation' | 'videos';

/** The mobile tab each section lives in; on desktop both columns show. */
export const SECTION_TAB: Record<PropertyDrawerSection, TabId> = {
  description: 'descricao',
  amenities: 'dados',
  ownership: 'descricao',
  documentation: 'descricao',
  videos: 'descricao',
};

/** The attribute that marks a section's wrapper inside the drawer. */
export const SECTION_ATTRIBUTE = 'data-drawer-section';

/** How long the drawer's open animation runs before the section is scrolled to. */
const SCROLL_DELAY_MS = 250;

/**
 * Scrolls the drawer to a section once the drawer has finished opening.
 *
 * @param section - The section to bring into view.
 * @returns A cleanup that cancels the pending scroll.
 */
export function scrollToSection(section: PropertyDrawerSection): () => void {
  const timer = window.setTimeout(() => {
    document
      .querySelector(`[${SECTION_ATTRIBUTE}="${section}"]`)
      ?.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }, SCROLL_DELAY_MS);
  return () => window.clearTimeout(timer);
}
